import { api } from "./client";
import { getActiveLang } from "../i18n";

/** POST /api/subscribe/ — backend emails the guide PDF matching `language`. */
export async function subscribeForGuide(email: string): Promise<void> {
  await api.post("/api/subscribe/", { email, language: getActiveLang() });
}
